import * as React from "react";
import Progress from "../../../common/organism/progress";
import { TOccupationCounts } from "../../../type/common";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import ClientTopPageMain from "./client_top_page_main";
import { Customer } from "../../../../domain/model/customer";
import { TJobCareerWithCustomerID } from "../../../../domain/repository/job_career_repository";
import { ClientBookmark } from "../../../../domain/model/client_bookmark";
import ClientTopPageHeader from "./client_top_page_header";

interface IProps {
  isInit: boolean;
  isLoading: boolean;
  customers: Customer[];
  occupationCounts: TOccupationCounts | null;
  jobCareersWithCustomerID: TJobCareerWithCustomerID[];
  clientBookmarks: ClientBookmark[];
  handleSearch: (values: any) => void;
}

const ClientTopPageComponent: React.FC<IProps> = (props) => {
  const {
    isInit,
    isLoading,
    customers,
    occupationCounts,
    jobCareersWithCustomerID,
    clientBookmarks,
    handleSearch,
  } = props;

  // 初期化
  if (isInit) {
    return <Progress canAnimation={false} />;
  }

  return (
    <>
      {isLoading && <Progress canAnimation={false} />}

      <ClientTopPageHeader handleSearch={handleSearch} />

      <PageWrapper>
        <ClientTopPageMain
          customers={customers}
          jobCareersWithCustomerID={jobCareersWithCustomerID}
          clientBookmarks={clientBookmarks}
          occupationCounts={occupationCounts}
          handleSearch={handleSearch}
        />
      </PageWrapper>
    </>
  );
};

export default ClientTopPageComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/client/top_page/client_top_page.tsx